module.exports = __webpack_public_path__ + "img/coupon-fill.fbcbf059.svg";